import { render, staticRenderFns } from "./WikiVpc.vue?vue&type=template&id=87e1eb2a&scoped=true"
import script from "./WikiVpc.vue?vue&type=script&lang=js"
export * from "./WikiVpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e1eb2a",
  null
  
)

export default component.exports